import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { buildWaLink } from "../data/site";
import { useLang } from "../data/i18n";

const WhatsAppIcon = ({ size = 24 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width={size}
        height={size}
        aria-hidden="true"
    >
        <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.413c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l.6.953-1.005 3.668 3.768-.987zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
    </svg>
);

/**
 * Compact icon-only floating WhatsApp button.
 * - Mobile: circular icon only.
 * - Desktop: expands on hover to reveal a label.
 */
export default function WhatsAppFloat() {
    const [show, setShow] = useState(false);
    const { t } = useLang();

    useEffect(() => {
        const tmo = setTimeout(() => setShow(true), 1200);
        return () => clearTimeout(tmo);
    }, []);

    return (
        <AnimatePresence>
            {show && (
                <motion.a
                    href={buildWaLink(t.waFloat.message)}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t.waFloat.aria}
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 220, damping: 18 }}
                    className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 flex items-center bg-coral hover:bg-coral-600 text-cream shadow-[0_12px_28px_rgba(235,103,65,0.45)] rounded-full overflow-hidden transition-[padding,width] duration-300 ease-out h-14 md:h-[56px] w-14 md:w-[56px] md:hover:w-[240px] md:hover:pr-6"
                    data-testid="whatsapp-float"
                >
                    <span className="flex-shrink-0 flex items-center justify-center w-14 md:w-[56px] h-14 md:h-[56px]">
                        <WhatsAppIcon size={26} />
                    </span>
                    {/* Label — desktop only, revealed on hover */}
                    <span className="hidden md:inline-block whitespace-nowrap text-[11px] uppercase tracking-[0.22em] font-bold opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-[180px] transition-all duration-300 ease-out">
                        {t.waFloat.label}
                    </span>
                </motion.a>
            )}
        </AnimatePresence>
    );
}
